// extracted by mini-css-extract-plugin
module.exports = {"info_block":"style_info_block__265mq","info_block__title":"style_info_block__title__2t89Y","info_block__text":"style_info_block__text__1QL4b"};